let user_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    meta: {isPublicRoute: false},
    children: [
      { path: 'users', name: 'users.list', component: () => import('./pages/Index.vue') },
      { path: 'users/create', name: 'users.create', component: () => import('./pages/Create.vue') },
      { path: 'users/:id/edit', name: 'users.edit', component: () => import('./pages/Edit.vue') },
      { path: 'onboarding', name: 'onboarding', component: () => import('./pages/OnBoarding.vue')},
      { path: '/account/:tab', name: 'account', component: () => import('./pages/account/Account.vue')},
    ]
  }
];

export default user_routes;
